import type React from 'react';

import { Button, Text } from '@change/ds-core-ui';

import { Translate } from '@change-corgi/core-react/i18n';

import { PRESS_MAILTO_HREF } from '#src/app/pages/about/press/shared/consts';

export const Hero: React.FC<EmptyProps> = () => {
	return (
		<section className="container pt-16 pb-16 md:pt-30 md:pb-32">
			<div className="mx-auto flex max-w-3xl flex-col items-center gap-4 text-center">
				<Text size="small" fontWeight="bold" className="text-typography-weak uppercase">
					<Translate value="corgi.press_page.title" />
				</Text>
				<Text as="h1" variant="heading" size="x-large" fontWeight="bold" data-qa="press-hero-heading">
					<Translate value="corgi.press_page.hero.heading" />
				</Text>
				<Text as="p" variant="body" size="large" className="text-typography-weak">
					<Translate value="corgi.press_page.hero.body" />
				</Text>
				<Button
					as="a"
					href={PRESS_MAILTO_HREF}
					variant="primary"
					size="large"
					className="w-full md:w-auto"
					data-qa="press-hero-email"
				>
					<Translate value="corgi.press_page.hero.email_button" />
				</Button>
			</div>
		</section>
	);
};
